import { Button, Flex } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	savedSignatureDataUrl: string;
	onUseSaved: () => void;
	onCreateNew: () => void;
}

export const SavedSignaturePicker = ({ savedSignatureDataUrl, onUseSaved, onCreateNew }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Flex direction="column" gap="md" w="100%">
			<Flex
				align="center"
				justify="center"
				p="md"
				style={{
					border: '1px solid #dee2e6',
					borderRadius: 4,
					background: 'white',
					minHeight: 120,
				}}
			>
				<img
					src={savedSignatureDataUrl}
					alt={tCommonUi('saved_signature_picker.preview_alt', {
						defaultValue: 'Saved signature',
					})}
					style={{ maxHeight: 100, maxWidth: '100%' }}
				/>
			</Flex>
			<Flex justify="space-between" gap="sm">
				<Button
					variant="subtle"
					onClick={onCreateNew}
					data-testid={TEST_ELEMENT_IDS.EID_EASY_SAVED_SIGNATURE_CREATE_NEW}
				>
					{tCommonUi('saved_signature_picker.create_new', {
						defaultValue: 'Create a new one',
					})}
				</Button>
				<Button variant="filled" onClick={onUseSaved}>
					{tCommonUi('saved_signature_picker.use_this', {
						defaultValue: 'Use this signature',
					})}
				</Button>
			</Flex>
		</Flex>
	);
};
